// extracted by mini-css-extract-plugin
module.exports = {"byz6efr":"byz6efr"};